module.exports = __webpack_public_path__ + "static/media/Brush.1ae09962.svg";